import md5 from 'js-md5'
import {uploadChunk} from '@/api/upload.js'
export const uploadByPieces = ({
  file,
  pieceSize = 1,
  concurrent = 1,
  success,
  process,
  error,
  type,
  mode,
  timeLimit
}) => {
  if (!file || file.size < 1) {
    return error && error('文件不能为空')
  }
  let fileMD5 = ''
  const chunkSize = pieceSize * 1024 * 1024
  const chunkCount = Math.ceil(file.size / chunkSize)
  console.log('分片大小(字节):', chunkSize)
  console.log('分片数量:', chunkCount)
  const chunkList = []
  let uploaded = []
  let fileType = ''
  let uploadId = ''

  const getChunkInfo = (file, currentChunk, chunkSize) => {
    let start = currentChunk * chunkSize
    let end = Math.min(file.size, start + chunkSize)
    let chunk = file.slice(start, end)
    return { start, end, chunk }
  }

  const createUploadData = (chunkInfo) => {
    let fetchForm = new FormData()
    fetchForm.append('identifier', fileMD5)
    fetchForm.append('chunkNumber', chunkInfo.currentChunk + 1)
    fetchForm.append('chunkSize', chunkSize)
    fetchForm.append('currentChunkSize', chunkInfo.chunk.size)
    const chunkfile = new File([chunkInfo.chunk], file.name)
    fetchForm.append('file', chunkfile)
    fetchForm.append('filename', file.name)
    fetchForm.append('relativePath', file.name)
    fetchForm.append('totalChunks', chunkInfo.chunkCount)
    fetchForm.append('totalSize', file.size)
    fetchForm.append('objectType', fileType)
    fetchForm.append('uploadId', uploadId)
    if(type !=2 ){
      fetchForm.append('width',file.width)
      fetchForm.append('height',file.height)      
    }else{
      
    }
    if(type != 1){
      fetchForm.append('duration',file.duration)
    }
    if(type == 3){
      fetchForm.append('minDuration',timeLimit?.minDuration || null)
      fetchForm.append('maxDuration',timeLimit?.maxDuration || null)
    }
    return fetchForm
  }

 // 示例：确保请求携带正确的认证信息
const uploadChunks = (data) => {
  // 添加认证头
  return uploadChunk(data, {
   /*  headers: {
      'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJyY3J6OXZIMUFsMW1FdU5oIiwiZXhwIjoxNzQ4OTc4Nzc5LCJqdGkiOiIwYmM5ZDkyMy02ZWVjLTQ0NzktODdjMS01ZTcyNThjZTIzODMiLCJjbGllbnRfaWQiOiJhZWU0NzlhZC00OGUxLTQ2ZTEtYmZlZC00YTVlMTJhMzUwMDUiLCJzY29wZSI6WyJ1Om9hdXRoLnVzZXI6ciJdfQ.SIWEntg8cov7D2dpRJAnpm82jjwtk5vJGCVtj5J0ewuWBVQD2E3A1xlojeoVfUbWKNDlEhw7f3aKuRyvBIsSwkTuWelOvAcqBy0afyU6ndDINaN7iTsYuiM1PZWl0tsVaPb3zRfkafjIgddeSDIqGyLiaeRWAh4euHzHYaiAgoHh4rgKepiz0_XTsxS8MU78V_WVBRr6_NGS3uMI4Gz2XfyMi9ERibgzzPzfGO3MUW78XYO21uNJiqZ_HLnbRCiYhQqhrC-yaFQUisWpi858g55ifB3TEh6BkZR-8_jEPVvH14QteIFNkt2RbslJptLNwz54tHdL6UiXxeKUqe8Mpg`
    } */
  });
};

  // 分片读取文件，生成MD5，启动上传
  const readFileMD5 = () => {
    fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
    const spark = new md5.create()
    
    let currentChunk = 0 // 初始化分块编号

    // 定义分片生成MD5
    const loadNextChunk = () => {
      const reader = new FileReader()
      const start = currentChunk * chunkSize
      const end = Math.min(file.size, start + chunkSize)
      const chunk = file.slice(start, end)

      console.log('分片生成md5中,第几次：', currentChunk)

      reader.onload = e => {
        spark.update(e.target.result)  // 增量更新MD5
        currentChunk++

        if(currentChunk < chunkCount) {
          loadNextChunk()
        } else {

          // 获取全部md5后，返回总的md5
          fileMD5 = spark.hex()

          console.log('生成了总md5', fileMD5)
          console.log('启动上传流程')
          startUploadPorcess()  // 启动上传方法
        }
      }

      reader.onerror = () => {
         // 获取具体的错误信息
        const errorMessage = reader.error ? reader.error.message : '未知错误'
        console.error('文件读取失败:', errorMessage)
        error && error(`文件读取失败: ${errorMessage}`)
      }

      reader.readAsArrayBuffer(chunk)
    }

    // 定义上传开始的方法
    const startUploadPorcess = () => {
      let form = new FormData()
      form.append('filename', file.name)
      form.append('identifier', fileMD5)
      form.append('objectType', fileType)
      form.append('chunkNumber', 1)
      form.append('uploadId', uploadId)
      form.append('totalSize', file.size)

      if(type !=2 ){
        form.append('width',file.width)
        form.append('height',file.height)      
      }else{
        
      }
      if(type != 1){
        form.append('duration',file.duration)
      }
      if(type == 3){
        form.append('minDuration',timeLimit?.minDuration || null)
        form.append('maxDuration',timeLimit?.maxDuration || null)
      }

      
      uploadChunks(form).then(res => {

        // 1. 检查服务器是否返回了skipUpload标记
        if (res.data?.skipUpload) {

          // 如果文件已存在服务器，直接触发成功回调
          success && success(res)
        } else {

          // 2. 记录服务器返回的上传ID（用于断点续传）
          uploadId = res.data.uploadId

          // 3. 如果服务器返回了已上传的分片列表，更新本地记录
          if (res.data.uploaded && res.data.uploaded.length) {
            uploaded = res.data.uploaded.slice()
          }

          // 4. 根据并发设置选择上传方式
          if (concurrent === 1 || chunkCount === 1) {
            sequentialUpload(0)  // 单线程顺序上传
          } else {
            concurrentUpload()  // 多线程并发上传
          }
        }
      }).catch(e => {
        error && error(e)
      })
    }

    loadNextChunk()
  }

  const sequentialUpload = (currentChunk) => {
    if (currentChunk >= chunkCount) {
      success && success({ message: '上传完成' })
      process && process(100)
      return
    }
    if (uploaded.includes(currentChunk + 1)) {
      sequentialUpload(currentChunk + 1)
      return
    }
    const { chunk } = getChunkInfo(file, currentChunk, chunkSize)
    let chunkInfo = { chunk, currentChunk, chunkCount }
    let uploadData = createUploadData(chunkInfo)
    uploadChunks(uploadData).then(res => {
      if (res.code === 200) {
        uploaded.push(currentChunk + 1)
        process && process(parseInt(((currentChunk + 1) / chunkCount) * 100))
        sequentialUpload(currentChunk + 1)
      } else {
        error && error(res.msg)
      }
    }).catch(e => error && error(e))
  }

  // 并发上传实现
  const concurrentExecution = (list, limit, asyncHandle) => {
    let recursion = (arr) => {
      if (arr.length === 0) return Promise.resolve('finished')
      return asyncHandle(arr.shift()).then(() => recursion(arr))
    }
    let listCopy = [...list]
    let asyncList = []
    limit = Math.min(limit, listCopy.length)
    while (limit--) {
      asyncList.push(recursion(listCopy))
    }
    return Promise.all(asyncList)
  }

  const concurrentUpload = () => {
    for (let i = 0; i < chunkCount; i++) {
      if (!uploaded.includes(i + 1)) {
        chunkList.push(i)
      }
    }
    concurrentExecution(chunkList, concurrent, curItem => {
      return new Promise((resolve, reject) => {
        const { chunk } = getChunkInfo(file, curItem, chunkSize)
        let chunkInfo = { chunk, currentChunk: curItem, chunkCount }
        if (uploaded.includes(curItem + 1)) {
          resolve()
          return
        }
        let uploadData = createUploadData(chunkInfo)
        uploadChunks(uploadData).then(res => {
          if (res.code === 200) {
            uploaded.push(curItem + 1)
            process && process(parseInt(((uploaded.length) / chunkCount) * 100))
            if (uploaded.length === chunkCount) {
              success && success(res)
            }
            resolve()
          } else {
            reject(res.msg)
          }
        }).catch(e => {
          error && error(e)
          reject(e)
        })
      })
    }).catch(e => error && error(e))
  }

  readFileMD5()
}
